// ======================================================================
// File Name       : SuperuserServiceRoleDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { superuserServiceRoleEdit } from '../../actions/SuperuserServiceRoleAction';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import RoleDetail from '../../components/superuserServiceRole/RoleDetail';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE, USER_AUTHORITY_ROLE } from '../../constants/AuthorityConstant';
import { AUTHORITY_EDIT, SUPERUSER_SERVICE_ROLE_EDIT } from '../../constants/FunctionConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import { MODE, WRITE } from '../../constants/index';
import { canAccess, canAccessRoute } from '../../utils/AuthedUtils';
import { SYSTEM_CREATE_FLAG } from '../../constants/CommonConstants';

class SuperuserServiceRoleDetailContainer extends React.Component {
  /**
     * Constructor function of component
     */
  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmModal: false,
    };
    this.onDeleteAuthorityCancel = this.onDeleteAuthorityCancel.bind(this);
    this.onDeleteAuthorityOk = this.onDeleteAuthorityOk.bind(this);
    this.openDeleteConfirmDialog = this.openDeleteConfirmDialog.bind(this);
  }

  /**
     * Life cycle function of component
     */
  componentDidMount() {
    const { superuserServiceRole, match, history } = this.props;
    const { authorityInfo: { roleList } } = superuserServiceRole;
    if (roleList.length === 0) {
      //  Back to superuser top
      history.push(Path.SUPERUSER_SERVICE_ROLE_LIST);
    } else {
      const authorityDetails = $.grep(
        roleList,
        e => e.superuserServiceRoleSecernId === match.params.id,
      );
      if (authorityDetails.length > 0) {
        const { managementFunctionAuthorityInfo } = authorityDetails[0];
        const authorityDisplayMapping = Object.keys(managementFunctionAuthorityInfo).reduce((acc, cur) => {
          acc[`${cur}Display`] = managementFunctionAuthorityInfo[cur] > 0
            ? MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
            : MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
          return acc;
        }, {});

        authorityDetails[0].managementFunctionAuthorityDisplayInfo = {
          ...authorityDisplayMapping,
        };
        this.setState({
          authorityInfo: authorityDetails[0],
        });
      }
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    const { superuserServiceRole, match } = nextProps;
    const { authorityInfo: { roleList } } = superuserServiceRole;
    const authorityDetails = $.grep(
      roleList, e => e.superuserServiceRoleSecernId === match.params.id,
    );

    if (superuserServiceRole.authorityInfo !== state.authorityInfo && authorityDetails.length > 0) {
      const { managementFunctionAuthorityInfo } = authorityDetails[0];
      const authorityDisplayMapping = Object.keys(managementFunctionAuthorityInfo).reduce((acc, cur) => {
        acc[`${cur}Display`] = managementFunctionAuthorityInfo[cur] > 0
          ? MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
          : MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
        return acc;
      }, {});
      authorityDetails[0].managementFunctionAuthorityDisplayInfo = {
        ...authorityDisplayMapping,
      };
      return {
        ...state,
        authorityInfo: authorityDetails[0],
      }
    }
    return state;
  }

  /**
     * Show delete authority confirm dialog
     * @param {*} mdContent
     * @param {*} mdSize
     */
  openDeleteConfirmDialog() {
    this.content = MessageTemplate.MSG_DEL_SUPERUSER_SERVICE_ROLE;
    this.setState({ showDeleteConfirmModal: true });
  }

  /**
     * Event button cancel of delete confirm dialog clicked
     */
  onDeleteAuthorityCancel() {
    this.setState({ showDeleteConfirmModal: false });
  }

  /**
     * Event button ok of delete confirm dialog clicked
     */
  onDeleteAuthorityOk() {
    this.setState({ showDeleteConfirmModal: false });
    const param = {
      editType: MODE.DELETE_MODE,
      roleInfo: {
        superuserServiceRoleSecernId: this.state.authorityInfo.superuserServiceRoleSecernId,
      },
    };
    const { history } = this.props;
    this.props.dispatch(superuserServiceRoleEdit(param)).then(() => {
      // go to superuser role top
      history.push(Path.SUPERUSER_SERVICE_ROLE_LIST);
    });
  }

  /**
     * Render function of component
     */
  render() {
    const { authorityInfo } = this.state;
    const canEditDelete = canAccessRoute(SUPERUSER_SERVICE_ROLE_EDIT);
    const editPath = authorityInfo
      ? `/${Path.SUPERUSER_SERVICE_ROLE}/${authorityInfo.superuserServiceRoleSecernId}/edit`
      : '';

    let showButton = false;
    if (
      authorityInfo &&
      authorityInfo.systemCreateFlag === SYSTEM_CREATE_FLAG.USER // Step 11.0.0
    ) {
      showButton = canAccess(SUPERUSER_SERVICE_ROLE_EDIT);
    }

    const isShowDetail =
      authorityInfo &&
      Object.keys(authorityInfo.managementFunctionAuthorityInfo).length > 0 &&
      Object.keys(authorityInfo.managementFunctionAuthorityDisplayInfo).length > 0;

    const headerName = authorityInfo && `サービスロールの詳細 - ${authorityInfo.superuserServiceRoleName}`;
    return (
      <div style={{ display: 'flow-root' }}>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.SUPERUSER_SERVICE_ROLE_LIST}
          text="サービスロール一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={headerName} />
        {isShowDetail && <RoleDetail authority={authorityInfo} isDetail />}
        <Form className='form-horizontal'>
          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="text-center">
              {showButton && canEditDelete && (
                <>
                  <Link className="btn btn-primary margin-10 btn-96" role="button" to={editPath}>
                    編集
                  </Link>
                  <Button
                    variant="primary"
                    className="btn-96 margin-10"
                    onClick={this.openDeleteConfirmDialog}
                  >
                    削除
                  </Button>
                </>
              )
              }
            </Col>
          </Form.Group>
        </Form>
        <DialogConfirm
          showModal={this.state.showDeleteConfirmModal}
          onCancel={this.onDeleteAuthorityCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteAuthorityOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ superuserServiceRole: state.superuserServiceRole },
});

export default connect(mapStateToProps)(SuperuserServiceRoleDetailContainer);
